export const ANSWER_MAX_LENGTH = 10000;
export const ANSWER_MAX_LENGTH_HARD = 16000;
export const COMMENT_MAX_LENGTH = 1000;
export const TEXT_INPUT_MAX_LENGTH = 255;
export const TEXT_INPUT_MIN_LENGTH = 5; 
